export default __webpack_public_path__ + "static/media/arrowRight.3071f714.svg";